export default "__VITE_ASSET__DBpb1jQo__"